export default __webpack_public_path__ + "static/rsforstudents_header_desktop-c2c3f63373c774fef6c59686005ef177.jpeg";